// extracted by mini-css-extract-plugin
export default {"heading-holder":"SimiliarInvestments_heading-holder__zQHUF"};